import './AuthnCard.less';
import ImprivataLogo from '@assets/Imprivata_Logo.svg?react';
import type React from 'react';
import { AuthnCardHeader } from './components/AuthnCardHeader/AuthnCardHeader';

interface AuthnLayoutProps {
  children: React.ReactNode;
  logoUrl?: string;
  hexImage?: React.ReactNode;
}

export const AuthnCard = ({ children, logoUrl, hexImage }: AuthnLayoutProps) => {
  return (
    <div className="authn-card">
      <AuthnCardHeader logoUrl={logoUrl} hexImage={hexImage} />
      <div className="authn-card-body">{children}</div>
      <div className="authn-card-footer">
        <ImprivataLogo />
      </div>
    </div>
  );
};
